import { apiCallWithoutToken } from "./apiService";
import { BIO_LEAD_FORM } from "@/constants/v2/endPoints";
import { contactEntry } from "@/helpers/reachEntry";

const withEntry = (body = {}) => {
  const entry = contactEntry();
  return entry && !body.entry ? { ...body, entry } : body;
};

export const submitBioLead = (slug, body) =>
  apiCallWithoutToken(BIO_LEAD_FORM.replace(":slug", encodeURIComponent(slug)), "POST", withEntry(body));

export const recordBioContact = (slug, body) =>
  apiCallWithoutToken(
    BIO_LEAD_FORM.replace(":slug", encodeURIComponent(slug)).replace(/buyer-form$/, "contacts"),
    "POST",
    withEntry(body),
  );

const bioPath = (slug, path) =>
  BIO_LEAD_FORM.replace(":slug", encodeURIComponent(slug)).replace(/buyer-form$/, path);

export const sendBioMessage = (slug, body) => apiCallWithoutToken(bioPath(slug, "messages"), "POST", withEntry(body));

export const confirmBioMessage = (token) =>
  apiCallWithoutToken(BIO_LEAD_FORM.replace(/agents\/:slug\/buyer-form$/, "messages/confirm"), "POST", { token });
